import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useTitle } from 'react-use';

import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { RoutedStepProps } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator.types';

import { IrshStepValues } from '../IrshPages.types';

import messages from './messages';
import useClaimGroupDiagnosticTreePage from './NewClaimGroupDiagnosticTreePage.hooks';
import { NewClaimGroupDiagnosticTreePageContent } from './NewClaimGroupDiagnosticTreePageContent';

export const NewClaimGroupDiagnosticTreePage: FC<
  RoutedStepProps<IrshStepValues>
> = ({ onPreviousStep, onNextStep }) => {
  const { questionId: diagnosticTreeUniqueName } = useParams() as {
    questionId: string;
  };

  useTitle(buildPageTitle([messages.claimGroupDiagnosticTreeTitlePage]));

  const { startOrContinueDiagnosticTreeQueryReturnValues } =
    useClaimGroupDiagnosticTreePage({
      diagnosticTreeUniqueName,
    });

  if (!startOrContinueDiagnosticTreeQueryReturnValues) {
    return <BaseLoader />;
  }

  return (
    <NewClaimGroupDiagnosticTreePageContent
      onPreviousStep={onPreviousStep}
      onNextStep={onNextStep}
      startOrContinueDiagnosticTreeQueryReturnValues={
        startOrContinueDiagnosticTreeQueryReturnValues
      }
    />
  );
};
